"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WordpressSquare;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function WordpressSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "WordPress"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "wordpress-square"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M81.429,7.5H18.571A11.084,11.084,0,0,0,7.5,18.571V81.429A11.084,11.084,0,0,0,18.571,92.5H81.429A11.084,11.084,0,0,0,92.5,81.429V18.571A11.084,11.084,0,0,0,81.429,7.5ZM87.5,81.429A6.079,6.079,0,0,1,81.429,87.5H18.571A6.079,6.079,0,0,1,12.5,81.429V18.571A6.079,6.079,0,0,1,18.571,12.5H81.429A6.079,6.079,0,0,1,87.5,18.571Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M50,29A21,21,0,1,0,71,50,21.024,21.024,0,0,0,50,29ZM31.117,50a18.748,18.748,0,0,1,1.634-7.68L41.761,67A18.9,18.9,0,0,1,31.117,50ZM50,68.883a18.8,18.8,0,0,1-5.335-.771L50.33,51.651l5.8,15.9a2.484,2.484,0,0,0,.135.262A18.9,18.9,0,0,1,50,68.883Zm2.6-27.732c1.134-.059,2.159-.178,2.159-.178a.781.781,0,0,0-.119-1.558s-3.057.237-5.03.237c-1.854,0-4.97-.237-4.97-.237a.781.781,0,0,0-.119,1.558s.966.119,1.982.178l2.938,8.061L45.309,61.6l-6.876-20.45c1.135-.059,2.159-.178,2.159-.178a.781.781,0,0,0-.118-1.558s-3.057.237-5.03.237c-.356,0-.771-.008-1.219-.025a18.882,18.882,0,0,1,28.527-3.556,2.224,2.224,0,0,0-.245-.017,3.267,3.267,0,0,0-3.167,3.353c0,1.558.9,2.87,1.854,4.428a9.911,9.911,0,0,1,1.558,5.208c0,1.617-.618,3.489-1.439,6.105l-1.88,6.292Zm13.971-.211a18.882,18.882,0,0,1-7.079,25.377l5.767-16.673A17.861,17.861,0,0,0,66.7,42.879,13.838,13.838,0,0,0,66.571,40.94Z"
  })))));
}